import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import englishServices from "../SdataEN";
import frenchServices from "../SdataFR";
import imageService_EN from "../images/PhotoServices_EN.png";
import imageService_FR from "../images/PhotoServices_FR.jpg";
import logo from "../images/logo.png";
import ServiceCard from "./ServiceCard";

const ServicesSection = ({ home }) => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState(
    i18n.language === "fr" ? frenchServices : englishServices
  );

  const language = i18n.language;
  const imageSrc = language === "fr" ? imageService_FR : imageService_EN;
  useEffect(() => {
    // Update service data whenever language changes
    setServices(i18n.language === "fr" ? frenchServices : englishServices);
  }, [i18n.language]);

  return (
    <section className="container my-5">
      {!home && (
        <div className="d-flex justify-content-center mb-4">
          <img
            src={imageSrc}
            className="img-fluid"
            alt="Services"
            style={{
              maxHeight: "400px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
      <h2 className="text-center mb-4 text-black"><strong>{t("Our_Services_Title")}</strong></h2>
      <div className="row justify-content-center animate__animated animate__fadeInDown">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            icon={service.icon}
            title={service.title}
            details={!home ? service.details : false}
            detailData={service.detailData}
          />
        ))}
      </div>
      {!home && (
        <div className="d-flex justify-content-center mb-4">
          <img
            src={logo}
            className="img-fluid"
            alt="Services"
            style={{
              maxHeight: "200px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </section>
  );
};

export default ServicesSection;
